import Vue from 'vue'
import Router from 'vue-router'
// 首页
import index from '@/components/index/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: ' index',
      component: index,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/components/index/index.vue'),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/goodsDetail',
      name: 'goodsDetail',
      component: () => import('@/components/classify/goodsDetail.vue'),
      meta: {
        title: '图文详情'
      }
    },
    {
      path: '/videoDetail',
      name: 'videoDetail',
      component: () => import('@/components/classify/videoDetail.vue'),
      meta: {
        title: '视频详情'
      }
    },
    {
      path: '/goodsDetail1',
      name: 'goodsDetail1',
      component: () => import('@/components/classify/goodsDetail1.vue'),
      meta: {
        title: '专栏图文详情'
      }
    },
    {
      path: '/getVideo',
      name: 'getVideo',
      component: () => import('@/components/classify/getVideo.vue'),
      meta: {
        title: '图文'
      }
    },

    {
      path: '/videoDetail1',
      name: 'videoDetail1',
      component: () => import('@/components/classify/videoDetail1.vue'),
      meta: {
        title: '专栏视频详情'
      }
    },
    {
      path: '/zhuanlan',
      name: 'zhuanlan',
      component: () => import('@/components/classify/zhuanlan.vue'),
      meta: {
        title: '专栏详情'
      }
    },
    {
      path: '/commentdet',
      name: 'commentdet',
      component: () => import('@/components/classify/commentdet.vue'),
      meta: {
        title: '评论详情'
      }
    },
    {
      path: '/zhiboing',
      name: 'zhiboing',
      component: () => import('@/components/index/zhiboing.vue'),
      meta: {
        title: '直播大厅'
      }
    },
    {
      path: '/msg',
      name: 'msg',
      component: () => import('@/components/personal/msg.vue'),
      meta: {
        title: '消息'
      }
    },
    {
      path: '/msgDet',
      name: 'msgDet',
      component: () => import('@/components/personal/msgDet.vue'),
      meta: {
        title: '消息详情'
      }
    },
    {
      path: '/my',
      name: 'my',
      component: () => import('@/components/personal/my.vue'),
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/classify',
      name: 'classify',
      component: () => import('@/components/classify/classify.vue'),
      meta: {
        title: '分类'
      }
    },
    {
      path: '/teacher',
      name: 'teacher',
      component: () => import('@/components/index/teacher.vue'),
      meta: {
        title: '导师'
      }
    },
    {
      path: '/jianjie',
      name: 'jianjie',
      component: () => import('@/components/index/jianjie.vue'),
      meta: {
        title: '公司简介'
      }
    },
    {
      path: '/newsInfo',
      name: 'newsInfo',
      component: () => import('@/components/index/newsInfo.vue'),
      meta: {
        title: '新闻资讯'
      }
    },
    {
      path: '/newsMore',
      name: 'newsMore',
      component: () => import('@/components/index/newsMore.vue'),
      meta: {
        title: '新闻详情'
      }
    },
    {
      path: '/zhibos',
      name: 'zhibos',
      component: () => import('@/components/index/zhibos.vue'),
      meta: {
        title: '直播大厅'
      }
    },
    {
      path: '/videoDetail',
      name: 'videoDetail',
      component: () => import('@/components/classify/videoDetail.vue'),
      meta: {
        title: '视频详情'
      }
    },
    {
      path: '/goodMore',
      name: 'goodMore',
      component: () => import('@/components/classify/goodMore.vue'),
      meta: {
        title: '精选课程更多'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js